export const appVersion = {
  version: 'v26.06.11',
  deploy: '-dev.39',
};
